import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  friend_id: any;
  user_id: any;
  friend: any = {};
  isLoading = false;
  sending = false;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.route.paramMap.pipe(
      switchMap(paramMap => {
        this.friend_id = paramMap.get('id');
        this.user_id = localStorage.getItem('user_id');
        this.isLoading = true;
        return this.apiService.getUserData(this.user_id, this.friend_id);
      })
    ).subscribe(
      (response) => {
        if (response.status == 'Success') this.friend = response;
        else alert('No data found!');
        this.isLoading = false;
      },
      (error) => {
        alert('Error fetching user data: ' + (error?.message || ''));
        this.isLoading = false;
      }
    );
  }

  get u(): any { return this.friend?.friend || {}; }

  get name(): string { return ((this.u.firstname || '') + ' ' + (this.u.lastname || '')).trim(); }

  get photo(): string {
    const p = this.u.profile_image;
    if (!p || typeof p !== 'string') return 'assets/images/avatar.png';
    return p.startsWith('data:image') || p.startsWith('http') ? p : 'data:image/jpeg;base64,' + p;
  }

  get subtitle(): string { return [this.u.job_title, this.u.company].filter(Boolean).join(' | '); }

  get location(): string {
    return [this.u.city, this.u.state, this.u.country].filter(Boolean).join(', ');
  }

  get socials(): { icon: string; url: string; label: string }[] {
    const mk = (v: string, base: string) =>
      v ? (v.startsWith('http') ? v : base + v.replace(/^@/, '')) : '';
    const w = this.u.website;
    return [
      { icon: 'fa-brands fa-facebook-f', label: 'Facebook', url: mk(this.u.facebook_url, 'https://facebook.com/') },
      { icon: 'fa-brands fa-x-twitter', label: 'X', url: mk(this.u.twitter_url, 'https://x.com/') },
      { icon: 'fa-brands fa-linkedin-in', label: 'LinkedIn', url: mk(this.u.linkedin_url, 'https://linkedin.com/in/') },
      { icon: 'fa-brands fa-youtube', label: 'YouTube', url: mk(this.u.youtube_url, 'https://youtube.com/') },
      { icon: 'fa-solid fa-globe', label: 'Website', url: w ? (w.startsWith('http') ? w : 'https://' + w) : '' }
    ].filter(s => s.url);
  }

  sendMessage() { this.router.navigate(['/messages']); }

  sendRequest() {
    if (this.sending) return;
    this.sending = true;
    this.apiService.sendRequest(this.user_id, parseInt(this.friend_id, 10)).subscribe(
      (response) => {
        this.sending = false;
        if (response.status == 'Success') this.friend.contacted = 'Pending';
        else alert('Failed to send request');
      },
      (error) => {
        this.sending = false;
        alert('Failed to send request: ' + (error?.message || ''));
      }
    );
  }
}